module.exports = __webpack_public_path__ + "img/git.94a869eb.svg";